import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import { CancelButton, CreateButton, FilterButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import PayablesTable from "./PayablesTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from 'yup';
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditPayable from "./MultiEditPayable";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

function PayablesIndex() {

  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("payablesViewMode") || "table"
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Status_Payable', showFilterDialog)
  const { value: Category } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Category__Payable', showFilterDialog)
  const { value: AccountType } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'AccountType__Payable', showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    category: "",
    accountType: "",
    status: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    category: "",
    accountType: "",
    status: ""
  });
  const clearFilter = () => {
    setParams({
      ...params, category: "",
      accountType: "",
      status: ""
    })
    formik.values.status = ""
    formik.values.accountType = ""
    formik.values.category = ""

    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, category: value.category, accountType: value.accountType, status: value.status })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        category: "",
        accountType: "",
        status: ""
      });
    }
  })
  // const { category: itemsCategory } = UseCatSubCatDropDown('/category/payableCategory', "payableCategory", formik?.values?.category);

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/payable/', params);

  const defaultHeaders = [
    {
      title: "Invoice In.",
      width: "10%",
      isLink: true,
      id: "payableId",
      link: '/payments/payables/view/',
      field: "invoiceRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Category",
      width: "10%",
      isLink: true,
      id: "payableId",
      link: '/payments/payables/view/',
      field: "category",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Amount",
      width: "10%",
      field: "amount",
      type: "amount",

      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Paid Amount",
      width: "10%",
      field: "paidAmount",
      type: "amount",

      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Days Elapsed",
      width: "10%",
      field: "daysElapsed",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "payableId",
        removeValue: "invoiceId",
        url: `/payable/`,
        moduleName: "Payable",
        from: `/payments/payables`,
        editLink: "/payments/payables/edit/",
        viewLink: "/payments/payables/view/"
      }
    },
  ];

  const availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "payableId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Invoice In.",
      width: "10%",
      isLink: true,
      id: "payableId",
      link: '/payments/payables/view/',
      field: "invoiceRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Category",
      width: "10%",
      isLink: true,
      id: "payableId",
      link: '/payments/payables/view/',
      field: "category",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Amount",
      width: "10%",
      field: "amount",
      type: "amount",

      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Paid Amount",
      width: "10%",
      field: "paidAmount",
      type: "amount",

      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Days Elapsed",
      width: "10%",
      field: "daysElapsed",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Account Type",
      width: "10%",
      field: "accountType",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Balance Amount",
      width: "10%",
      field: "balanceAmount",
      type: "amount",

      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Description",
      width: "10%",
      field: "description",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Due Date",
      width: "10%",
      field: "dueDate",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Pay To",
      width: "10%",
      field: "payToName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "payableId",
        removeValue: "invoiceRef",
        url: `/payable/`,
        moduleName: "Payable",
        from: `/payments/payables`,
        editLink: "/payments/payables/edit/",
        viewLink: "/payments/payables/view/"
      }
    },
  ];

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some(Item => Item === value)) {
      NewId = listofNumbers.filter(Temp => Temp !== value);
      setListofNumbers(NewId)
    } else {
      setListofNumbers([...listofNumbers, value])
    }
  }

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList)
    } else {
      setListofNumbers([])
    }
  }

  useEffect(() => {
    let tempArr = []
    data && data.forEach(i => {
      tempArr.push(i?.payableId)
    });
    setFullList(tempArr)
  }, [data])


  return (
    <div className='w-full h-full px-2 sm:px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className='w-full md:w-auto flex justify-between items-center gap-2'>
          <Breadcrumb
            items={[
              { name: "Payment" },
              { name: "Payable" },
            ]}
          />
          <div className='flex md:hidden items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2'>
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className='hidden md:flex items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>


          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="payablesViewMode"
          />

        </div>
      </div>

      <PayablesTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        searchQuery={params?.search !== "" ? params?.search : ""}
        listofNumbers={listofNumbers}
        selectOneFunction={selectOneFunction}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        fetcher={getData}
        dataLoading={dataLoading}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        viewMode={effectiveViewMode}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Payables</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <FormikSelectTwo
                  label="Category"
                  placeholder="Choose"
                  Options={Category}
                  formik={formik}
                  name="category"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Account Type"
                  placeholder="Choose"
                  Options={AccountType}
                  formik={formik}
                  name="accountType"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full"
                />

              </div>
              <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name='Apply' />
              </div>
            </form>
          </div>
        </div>
      )}
      {showEdit && (<MultiEditPayable data={listofNumbers} getData={getData} onClose={() => setShowEdit(false)} />)}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  )
}

export default PayablesIndex;